import { Button } from "antd";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useState } from "react";

import { syncFirebaseUser } from "../api";
import { showErrorToast, showSuccessToast } from "@src/appV2/lib/Notifications";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'userId' implicitly has an 'any' type.
function FirebaseSyncButton({ userId, retrieveUser }) {
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    const { success, error } = await syncFirebaseUser(userId);
    if (success) {
      showSuccessToast("Mobile login generated");
      retrieveUser();
    } else {
      showErrorToast(error);
    }
    setLoading(false);
  };

  return (
    <Button type="primary" loading={loading} onClick={onClick}>
      Sync Mobile Login
    </Button>
  );
}

export { FirebaseSyncButton };
